<template>
  <div
    ref="myElement"
    class="relative bg- p-1 flex justify-center items-center"
    style="width: 50px; height: 50px"
  >
    <img
      :src="require(`./icons/${iconType}.png`)"
      class="flex-1 max-h-full"
      ref="test"
      :style="finalProps"
      style="object-fit: contain"
    />
    <div
      v-if="data"
      class="flex flex-no-wrap"
      :style="{
        position: `absolute`,
        width: 'fit-content',
        height: 'fit-content',
        left: '50%',
        top: '-0%',
        transform: `translate(-50%,-100%) `,
        borderRadius: '3px',
        overflow: 'hidden',
        boxShadow: '0 0 0 2px black',
      }"
    >
      <div
        class="justify-center items-center text-black flex flex-1"
        style="background: #000"
      >
        <svg
          :style="{
            transform: `rotate(${data.data.rotation}deg)`,
          }"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <path
            :fill="data.data.color"
            d="M13 18v-8l3.5 3.5l1.42-1.42L12 6.16l-5.92 5.92L7.5 13.5L11 10v8h2M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"
          />
        </svg>
      </div>
      <div
        :style="{
          width: 'fit-content',
          height: 'fit-content',
          background: data.data.color,
          color: 'black',
          padding: '4px',
          whiteSpace: 'nowrap',
          fontSize: '10px',
        }"
      >
        {{ data.data.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  computed: {
    iconType() {
      let icon = 'truck-1';
      if (!this.data.data.iconType) return icon;
      return this.data.data.iconType;
    },
    baseProps() {
      return {
        filter: this.hue[this.data.data.status],
        transform: `rotate(${this.data.data.rotation}deg)`,
      };
    },
    finalProps() {
      let style = this.baseProps;
      if (this.iconProps[this.iconType]) {
        //
      }
      return style;
    },
  },
  data() {
    return {
      // Your component data goes here
      hue: {
        Parked: 'hue-rotate(0deg) brightness(1)',
        Idling: 'hue-rotate(37deg) brightness(1.2)',
        Moving: 'hue-rotate(146deg) brightness(1.3)',
        Inactive: 'grayscale(1) brightness(1)',
      },
      iconList: { animal: 1, boat: 2, car: 1, machine: 1, truck: 3, item: 1, watch:1 , staff:1 },
      iconProps: {},
    };
  },
  methods: {},
  mounted() {
    // console.log(this.data);
  },
};
</script>

<style scoped></style>
